import { RouterProvider } from '@climate-x-org/ui-kit'
import { createRootRoute, Outlet, useRouter } from '@tanstack/react-router'

// Lets kit components that take `href` navigate through TanStack Router
// instead of doing a full page load.
const KitRouterProvider = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter()
  return (
    <RouterProvider
      navigate={(to) => router.navigate({ to })}
      useHref={(to) => router.buildLocation({ to }).href}
    >
      {children}
    </RouterProvider>
  )
}

const RootComponent = () => (
  <KitRouterProvider>
    <Outlet />
  </KitRouterProvider>
)

export const Route = createRootRoute({
  component: RootComponent,
})
